// extracted by mini-css-extract-plugin
module.exports = {"root":"Accordian_root__vTWid","dark":"Accordian_dark__cywva","light":"Accordian_light__lsH_7"};